import { WhatsNextItem } from '../pages/Dashboard/WhatsNext';

export const data: WhatsNextItem[] = [
  {
    icon: 'tag',
    title: 'Sell an item',
    body: 'Ready to list your next item. Let us know what you have to sell.',
    actionContent: 'List my item',
    actionLink: '/sell',
  },
  {
    icon: 'megaphone',
    title: 'Promote',
    body: 'Promote your item to attract more bidders and increase your earnings.',
    actionContent: 'Promote item',
    actionLink: 'promotemodal',
  },
  {
    icon: 'envelope',
    title: 'Contact Grays',
    body: 'Get in touch with your Grays representative.',
    actionContent: 'Contact',
    actionLink: 'contactmodal',
  },
  {
    icon: 'cart',
    title: 'Your items',
    body: 'Get updates on your pending, active, sold and unsold items in Listings.',
    actionContent: 'View my listings',
    actionLink: '/listings',
  },
];
